// extracted by mini-css-extract-plugin
export default {"nakleyka":"Var_nakleyka__bwc7l","barcode":"Var_barcode__f1m8n"};